import { store } from '@betacrew/jars-flux'

export const componentKey = "BOI/FILE_BOI";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setReportingCompanyLoadingState: (state, action) => {
            state.reportingCompanyLoadingState = action.payload;
        },
        setStepperRefreshStep: (state, action) => {
            state.stepperRefreshStep = action.payload;
        },
        setPayerListPaginationState: (state, action) => {
            state.payerListPaginationState = { ...state.payerListPaginationState, ...action.payload }
        },
        setRecipientListPaginationState: (state, action) => {
            state.recipientListPaginationState = { ...state.recipientListPaginationState, ...action.payload }
        },
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setRecipientList: (state, action) => {
            state.recipientList = action.payload;
        },
        setGridSelectedPayers: (state, action) => {
            state.gridSelectedPayers = action.payload;
        },
        setReportingCompanyScreenNxtBtnClicked: (state, action) => {
            state.reportingCompanyScreenNxtBtnClicked = action.payload;
        },
        updateBoiFormFields: (state, action) => {
            state.boiFormFields = { ...state.boiFormFields, ...action.payload }
        },
        setFormRecordId: (state, action) => {
            state.formRecordId = action.payload;
        },
        setErrorInFormFieldsOrFormData: (state, action) => {
            state.errorInFormFieldsOrFormData = action.payload;
        },
        setGridSelectedRecipients: (state, action) => {
            state.gridSelectedRecipients = action.payload;
        },
        setOnDependentFields: (state, action) => {
            state.onDependentFields = action.payload;
        },
        setFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = action.payload;
        },
        updateFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = {
                ...state.formsPreLoadedData,
                ...action.payload,
            }
        },
        setIsBeneficiaryAddEditPopupOpen: (state, action) => {
            state.isBeneficiaryAddEditPopupOpen = action.payload;
        },
        setIsAddNewBenefiarySelected: (state, action) => {
            state.isAddNewBenefiarySelected = action.payload;
        },
        setReportingCompanyDetailId: (state, action) => {
            state.reportingCompanyDetailId = action.payload;
        },
        setLoadDependentFieldsArr: (state, action) => {
            state.loadDependentFieldsArr = action.payload;
        },
        setReloadPayersList: (state, action) => {
            state.reloadPayersList = action.payload;
        },
        setReloadBeneficiaryList: (state, action) => {
            state.reloadBeneficiaryList = action.payload;
        },
        setGoToManageBoiScreen: (state, action) => {
            state.goToManageBoiScreen = action.payload;
        },
        setDefaultReporingCompanyFieldsArr: (state, action) => {
            state.defaultReporingCompanyFieldsArr = action.payload;
        },
        setUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = action.payload;
        },
        updateUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {
                ...state.userInteractionPopupWResponseObj,
                ...action.payload,
            };
        },
        resetUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {};
        },
        setSelectedBeneficialDetailIds: (state, action) => {
            state.selectedBeneficialDetailIds = action.payload;
        },
        setReviewStepSelectedBeneficialsData: (state, action) => {
            state.reviewStepSelectedBeneficialsData = action.payload;
        },
        setSelectedCompanyApplicantIds: (state, action) => {
            state.selectedCompanyApplicantIds = action.payload;
        },
        setIsBeneficialSelectAllSelected: (state, action) => {
            state.isBeneficialSelectAllSelected = action.payload;
        },
        setShowHelpPopup: (state, action) => {
            state.showHelpPopup = action.payload;
        },
        setHelpTextObj: (state, action) => {
            state.helpTextObj = action.payload;
        },
        updateHelpTextObj: (state, action) => {
            state.helpTextObj = {
                ...state.helpTextObj,
                ...action.payload,
            };
        },
    },
    initialReducerState: {
        loadingState: false,
        reportingCompanyLoadingState: false,
        stepperRefreshStep: 0,
        payerListPaginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: false,
            Skip: 0,
            totalRecords: 10,
        },
        recipientListPaginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: false,
            Skip: 0,
            totalRecords: 10,
        },
        payersList: [],
        gridSelectedPayers: [],
        reportingCompanyScreenNxtBtnClicked: false,
        boiFormFields: {},
        formRecordId: 0,
        errorInFormFieldsOrFormData: false,
        recipientList: [],
        gridSelectedRecipients: [],
        onDependentFields: {},
        formsPreLoadedData: {},
        isBeneficiaryAddEditPopupOpen: false,
        isAddNewBenefiarySelected: false,
        reportingCompanyDetailId: 0,
        loadDependentFieldsArr: false,
        reloadPayersList: false,
        reloadBeneficiaryList: false,
        goToManageBoiScreen: false,
        defaultReporingCompanyFieldsArr: [],
        userInteractionPopupWResponseObj: {},
        selectedBeneficialDetailIds: "",
        selectedCompanyApplicantIds: "",
        reviewStepSelectedBeneficialsData: [],
        isBeneficialSelectAllSelected: false,
        showHelpPopup: false,
        helpTextObj: {},
    }
});

export const { setLoadingState, setReportingCompanyLoadingState, setStepperRefreshStep, setPayerListPaginationState, setRecipientListPaginationState, setPayersList, setGridSelectedPayers, setReportingCompanyScreenNxtBtnClicked, updateBoiFormFields, setFormRecordId, setErrorInFormFieldsOrFormData, setRecipientList, setGridSelectedRecipients, setOnDependentFields, setFormsPreLoadedData, updateFormsPreLoadedData, setIsBeneficiaryAddEditPopupOpen, setIsAddNewBenefiarySelected, setReportingCompanyDetailId, setLoadDependentFieldsArr, setReloadPayersList, setReloadBeneficiaryList, setGoToManageBoiScreen, setDefaultReporingCompanyFieldsArr, setUserInteractionPopupWResponseObj, updateUserInteractionPopupWResponseObj, resetUserInteractionPopupWResponseObj, setSelectedBeneficialDetailIds, setReviewStepSelectedBeneficialsData, setSelectedCompanyApplicantIds, setIsBeneficialSelectAllSelected, setShowHelpPopup, setHelpTextObj, updateHelpTextObj, } = actions;